import { createAction, props } from '@ngrx/store';
import { EmployeeGroup } from '@fc-core';

import { SortBy } from '@fc-shared/ui/sort-by/sort-by';

export const loadEmployeeGroups = createAction(
  '[UserGroup/API] Load Employee Groups',
);

export const loadEmployeeGroupsSuccess = createAction(
  '[UserGroup/API] Load Employee Groups Success',
  props<{ userGroups: EmployeeGroup[] }>(),
);

export const employeeGroupsFailure = createAction(
  '[UserGroup/API] Load Employee Groups Failure',
  props<{ error: any }>(),
);

export const updateUserGroup = createAction(
  '[UserGroup/API] Update UserGroup',
  props<{ userGroup: EmployeeGroup }>(),
);
export const addEmployeesToGroup = createAction(
  '[UserGroup/API] Add Employees To Groups',
  props<{ groupId: number; employeeList: string[] }>(),
);
export const addEmployeeToGroups = createAction(
  '[UserGroup/API] Add Employee To Groups',
  props<{ employeeId: string; groups: number[] }>(),
);
export const addEmployeesToGroupSuccess = createAction(
  '[UserGroup/API] Add Employees To Groups Success',
  props<{ group: EmployeeGroup }>(),
);
export const removeEmployeesFromGroup = createAction(
  '[UserGroup/API] Remove Employees From Group',
  props<{ groupId: number; employeeList: string[] }>(),
);
export const removeEmployeesFromGroupSuccess = createAction(
  '[UserGroup/API] Remove Employees From Groups Success',
  props<{ userGroup: EmployeeGroup }>(),
);
export const updateUserGroupSuccess = createAction(
  '[UserGroup/API] Update UserGroup Success',
  props<{ userGroup: EmployeeGroup }>(),
);

export const createUserGroup = createAction(
  '[UserGroup/Api] Create User Group',
  props<{ userGroup: EmployeeGroup }>(),
);
export const createUserGroupSuccess = createAction(
  '[UserGroup/Api] Create User Group Success',
  props<{ userGroup: EmployeeGroup }>(),
);

export const deleteUserGroup = createAction(
  '[UserGroup/api] Delete User group',
  props<{ groupId: number }>(),
);
export const deleteUserGroupSuccess = createAction(
  '[UserGroup/api] Delete User group Success',
  props<{ groupId: number }>(),
);

export const searchUserGroup = createAction(
  '[UserGroup] Search user group',
  props<{ searchText: string }>(),
);

export const setUserGroupSortBy = createAction(
  '[UserGroup] Set User Group Sort By',
  props<{ sortBy: SortBy }>(),
);

export const resetEmployeeGroupFilters = createAction(
  '[UserGroup] Reset Employee Group Sort By',
);
